import { Coverage, VehicleCoverage } from '@/interfaces';
import { isComprehensiveCarOrIsFireTheftAndThirdPartyCarOrIsThirdPartyPropertyDamageCar } from '@/pages/my-racq/insurance/product-details/PolicyDetailsMotorCoverageMapper';

/**
 * Determines whether to show the 'primary/edit' link for ChangeVehicle.
 * SSINSP.FR8.3
 */
export const isChangeVehicleAllowed = (coverage: VehicleCoverage | Coverage): boolean => {
  if (isComprehensiveCarOrIsFireTheftAndThirdPartyCarOrIsThirdPartyPropertyDamageCar(coverage)) {
    return true;
  }
  return false;
};

/**
 * Determines whether to show the 'primary/edit' link for ChangeVehicleLocation.
 * SSINSP.FR8.4
 */
export const isChangeVehicleLocationAllowed = (coverage: VehicleCoverage | Coverage): boolean => {
  if (isComprehensiveCarOrIsFireTheftAndThirdPartyCarOrIsThirdPartyPropertyDamageCar(coverage)) {
    return true;
  }
  return false;
};

export const SSInsuranceProductDetailsPolicyEditRules = {
  //////////// Motor ////////////
  isChangeVehicleAllowed,
  isChangeVehicleLocationAllowed,
  //////////// Motor ////////////
};
